/* !
 * newsletter.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	const yearSelect = () => {
		const latest = document.querySelector('.js-latest').textContent;
		const earliest = document.querySelector('.js-earliest').textContent;
		const yearList = document.querySelector('.js-news-yearList .mod-pulldown-ul');
		const head = document.querySelector('.js-news-yearList summary span');

		const first = Math.floor((Number(earliest) - 1) / 5) * 5 + 1;
		const last = Math.floor((latest - 1) / 5) * 5 + 1;

		for (let start = last; start >= first; start -= 5) {
			const end = start + 4;
			let item = yearList.appendChild(document.createElement('li')).appendChild(document.createElement('a'));
			item.setAttribute('href', `/corporate/newsletter/${start}/`);
			item.textContent = `${start}年～${end}年`;
		}

		// 現在年を選択状態にする
		if (!location.pathname.endsWith('/corporate/newsletter/') && !location.pathname.endsWith('/corporate/newsletter/index.html')) {
			yearList.querySelectorAll('a').forEach(ele => {
				if (ele.getAttribute('href') === location.pathname) {
					head.textContent = ele.textContent;
				}
			});
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsletterFUNCTIONS = () => {
		yearSelect();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsletterFUNCTIONS(); }) : newsletterFUNCTIONS();

})(window.FUNCTIONS);
